import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  input,
  output,
} from '@angular/core';

@Component({
  selector: 'casa-doc-confirm-dialog',
  standalone: true,
  imports: [],
  templateUrl: './confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  open = input<boolean>(false);
  title = input<string>('Sei sicuro?');
  message = input<string>('');
  confirmLabel = input<string>('Conferma');
  cancelLabel = input<string>('Annulla');

  confirm = output<void>();
  cancel = output<void>();

  onConfirm() {
    this.confirm.emit();
  }

  onCancel() {
    this.cancel.emit();
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    if (this.open()) {
      this.cancel.emit();
    }
  }
}
